import { ReactNode } from "react";
import { StiggProvider } from "@stigg/react-sdk";
import { StiggProviderProps } from "@stigg/react-sdk/src/components/StiggProvider";

type Props = StiggProviderProps & { children: ReactNode };
export function StiggWrapper({ children, ...stiggProps }: Props) {
  const stiggTheme = {
    palette: {
      primary: "#6666fc", // Indigo color that matches the brand
      backgroundPaper: "#FFFFFF", // Slate-800
      outlinedBorder: "#FFFFFF",
      backgroundHighlight: "#FFFFFF", // Slate-700
      backgroundSection: "#FFFFFF", // Slate-700
      text: {
        primary: "#020817",
        secondary: "#020817",
        tertiary: "#020817",
        disabled: "#020817",
      },
    },
    typography: {
      fontFamily:
        "'Inter', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif",
    },
    customCss: `
      .stigg-checkout-layout {
        min-height: 0px !important;
        border: none !important;
        padding: 0px !important;
      }
    `,
  };

  return (
    <StiggProvider {...stiggProps} theme={stiggTheme}>
      {children}
    </StiggProvider>
  );
}
